var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{staticClass:"pt-5"},[_c('improve-b')],1),_c('hr',{staticClass:"border-0 bottom-space"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }